import React, {useRef} from 'react';
import GoogleDrivePicker from './GoogleDrivePicker';
import { useUploadFolderId } from '../util/UploadFolderIdContext';
import styles from './PageEdit.module.css'
import { FaFolderOpen } from "react-icons/fa";
import { TiDelete } from "react-icons/ti";

export default function SelectImage({ onSelect }) {
  const serverUrl =
    process.env.NODE_ENV === 'development'
      ? 'http://localhost:3000'
      : 'https://api.hillerodfrimenighed.dk';

  const folderId = useUploadFolderId();
  const fileInputRef = useRef(null);

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleClear = () => {
    onSelect("")
  }

  const handleImagePick = ({ fileId }) => {
    const newImageUrl = `${serverUrl}/drive/proxyImage/${fileId}`;
    onSelect(newImageUrl);
  };

  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await fetch(`${serverUrl}/drive/uploadImage?folderId=${folderId}`, {
        method: 'POST',
        body: formData,
        credentials: 'include',
      });

      const data = await response.json();
      if (data.success && data.proxyUrl) {
        onSelect(data.proxyUrl);
      } else {
        console.error('Upload failed:', data);
      }
    } catch (err) {
      console.error('Upload error:', err);
    }
  };

  return (
    <div className={styles.imageSelector}>
      <div className={styles.imageSelectorBnt}>

        <GoogleDrivePicker onPick={handleImagePick} />

        <FaFolderOpen className={styles.iconBnt} onClick={handleClick}/>
          <input 
            type="file"
            ref={fileInputRef}
            onChange={handleImageUpload} 
            style={{display: 'none'}}
          />
      
        <TiDelete className={`${styles.iconBnt} ${styles.deleteIcon}`} onClick={handleClear}/>

      </div>
    </div>
  );
}
